import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaPhone,
  FaTwitter
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logo.png';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-brand">
              <img src={logoImage} alt="KSA Holidays Travel & Tourism" className="footer-logo" />
            </div>
            <p className="footer-description">
              Creating unforgettable travel experiences for families and adventurers worldwide.
              Explore the world with confidence and comfort.
            </p>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/tours">Tours</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Tour Categories */}
          <div className="footer-section">
            <h4>Tour Categories</h4>
            <ul className="footer-links">
              <li><Link to="/tours?category=Domestic Tours#tours">Domestic Tours</Link></li>
              <li><Link to="/tours?category=International Tours#tours">International Tours</Link></li>
              <li><Link to="/tours?category=Inbound and Outbound Tours#tours">Inbound and Outbound Tours</Link></li>
              <li><Link to="/tours?category=Family Tours#tours">Family Tours</Link></li>
              <li><Link to="/tours?category=Group Tours#tours">Group Tours</Link></li>
              <li><Link to="/tours?category=Honeymoon Couple Tours#tours">Honeymoon Couple Tours</Link></li>
            </ul>
          </div>

          {/* Useful Links */}
          <div className="footer-section">
            <h4>Useful Links</h4>
            <ul className="footer-links">
              <li><Link to="/terms">Terms & Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/cancellation">Cancellation Policy</Link></li>
              <li><Link to="/refund">Refund Policy</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Contact Us</h4>
            <div className="contact-info">
              <div className="contact-item">
                <FaPhone />
                <div className="contact-numbers">
                  <span>+91 9731395805</span>
                </div>
              </div>
              <div className="contact-item">
                <FaEnvelope />
                <span>tours@ksaholidays.in</span>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt />
                <span>Bangalore, Karnataka, India</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} KSA Holidays. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy">Privacy Policy</Link>
              <span>|</span>
              <Link to="/terms">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
